module.exports = __webpack_public_path__ + "static/img/sapodilla.0c8a84b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/sapodilla.jpg
// module id = QCrl
// module chunks = 1